import { Pipe, PipeTransform } from '@angular/core';
import { genericSort } from './utils/generic-sort.utils'; // Adjust the path accordingly

@Pipe({ name: 'genericsort' })
export class GeniricSortPipe implements PipeTransform {
  transform(items: any[], column: string = '', order: 'asc' | 'dsc' = 'asc'): any[] {
    return genericSort(items, column, order);
  }
}
